/** @file Converts the document's view.grid into an overlay GridSpec (spec 5.10: isoAngle 30 derives tileH). */
import { isoTileHeight } from '@pose2d/core/direction/isoTileHeight';
import type { ViewDoc } from '@pose2d/format/types';
import type { GridSpec } from './overlayOptions';

/** null when the grid is off; iso with isoAngle 30 uses tileH = isoTileHeight(tileW) (W2-24) and ignores tileH. */
export function gridSpecFromView(grid: ViewDoc['grid']): GridSpec | null {
  if (grid.mode === 'off') return null;
  const tileH = grid.mode === 'iso' && grid.isoAngle === 30 ? isoTileHeight(grid.tileW) : grid.tileH;
  return { mode: grid.mode, tileW: grid.tileW, tileH, footprint: grid.footprint === null ? null : { ...grid.footprint } };
}
